/*
 * @module onchange
 * Enable onchange of state object by adding this adapter
 */
define('shared/util/state/adapters/onChange',['shared/util/state', 'shared/lib/Emitter'], 
function(state, Emitter){

    var ret = {
        "isApplicable" : function (key) {
            return true;
        },

        "afterPut" : function (state, key, value) {
            var me = this;

            if ( key == null && value == null ) {
                return;
            }

            // make sure onChange event is fired after all the other adapters' afterPut is done
            setTimeout(function(){
                me.emit('change', key, value);
            },0);
        }
    };

    Emitter(ret);

    return ret;
});
